var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{style:(_vm.getStyle()),attrs:{"tile":"","size":_vm.size,"color":_vm.logo ? 'transparent' : 'primary'},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.logo && !_vm.error)?_c('img',{attrs:{"alt":"Logo","src":_vm.getImage()},on:{"error":_vm.imageError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }